import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import logo from "../../assets/transparent_logo.png";
import BAScreenHeader from "../components/BAScreenHeader";
import BAButton from "../components/BAButton";
import BASelect from "../../config/components/BASelect";
import { useReactToPrint } from "react-to-print";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { setDate } from "./helpermethod";
import BAGrid from "../components/BAGrid";
import { Box, Grid, Typography } from "@mui/material";
import '../../style.css'

function PageHeader() {
  return (
    <>
      <div
        style={{ borderRadius: '0 0 30px 0' }}
        className="d-flex bgLight px-3 justify-content-between align-items-center"
      >
        <div>
          <h1 className="m-0 p-0">Estimate</h1>
        </div>
        <div className="pt-2" style={{ backgroundColor: "#052027", borderRadius: "0 0 50px 50px" }}>
          <img src={logo} width="80px" alt="Logo" />
        </div>
      </div>
    </>
  );
}
function PageFooter() {
  return (
    <>
      <div
        style={{ backgroundColor: "#04191e", borderRadius: "30px 30px 0 0" }}
        className="p-3 text-white"
      >
        <div>
          <p className="p-0 m-0">
            <span className="me-2" style={{ color: "#e9c474" }}>
              <LocalPhoneIcon />
            </span>{" "}
            +923004128984
          </p>
          <p className="p-0 m-0">
            <span className="me-2" style={{ color: "#e9c474" }}>
              <EmailIcon />
            </span>{" "}
            mubashircurtain786@gmail.com
          </p>
          <p className="p-0 m-0">
            <span className="me-2" style={{ color: "#e9c474" }}>
              <HomeWorkIcon />
            </span>{" "}
            shop #28 sawana city near waseem bagh 13-D/3 gulshan-e-iqbal
            Karachi,
          </p>
        </div>
      </div>
    </>
  );
}

function PrintEstimateDoc(props) {
  const {
    customerName,
    companyName,
    contactNo,
    email,
    address,
    description,
    installationCharges,
    totalAmount,
    detailsArray,
    estimatedDays
  } = props.model;
  const imageRef = useRef(null);

  const [printBy, setPrintBy] = useState(2);

  const generateImage = async () => {
    if (imageRef.current) {
      const canvas = await html2canvas(imageRef.current);
      const imageSrc = canvas.toDataURL("image/png");
      shareImage(imageSrc);
    }
  };
  const createPdf = useReactToPrint({
    content: () => imageRef.current,
    documentTitle: "Estimate",
  });

  const shareImage = (imageSrc) => {
    // const whatsappURL =
    //   "https://api.whatsapp.com/send?text=" +
    //   encodeURIComponent(whatsappMessage) +
    //   "&image=" +
    //   encodeURIComponent(imageSrc);

    // window.open(whatsappURL, "_blank");
    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = "Estimate";
    link.click();
  };

  const createPages = (list) => {
    for (let i = 0; i < detailsArray.length; i++) {
      detailsArray[i].sNo = i + 1;
    }
    let arr = [];
    for (let i = 0; i <= list.length; i += 5) {
      let a = list.slice(i, i + 5)
      if (a.length > 0) {
        arr.push(a);
      }
    }
    return arr;
  };

  useEffect(() => {

    if (createPages(detailsArray).length > 1) {
      setPrintBy(2);
    }
  }, []);

  return (
    <div className="bg-transparent">
      <BAScreenHeader
        title="Print Invoice"
        buttonsList={[
          {
            displayField: (
              <BASelect
                onChange={(e) => setPrintBy(e.target.value)}
                value={printBy}
                datasource={[
                  {
                    id: 2,
                    displayName: "PDF",
                  },
                ]
                }
                valueField="id"
                displayField="displayName"
                label="print"
              />
            ),
          },
          {
            displayField: (
              <BAButton
                onClick={printBy == 1 ? generateImage : createPdf}
                label="print"
              />
            ),
          },
        ]}
      />
      <div
        style={{ position: "relative", width: "fit-content", margin: "auto" }}
      >
        <div className="bg-white" ref={imageRef}>
          {createPages(detailsArray).map((pageList, ind) => (
            <div
              style={{ height: "1060px", width: "820px" }}
              className="d-flex flex-column justify-content-between"
              key={ind}
            >
              <PageHeader />
              <div>
                {ind == 0 && (
                  <div className="d-flex mb-2 p-3">
                    <div className="w-100">
                      <Typography className="fw-bold text-decoration-underline mb-2" variant="h5">Customer Information</Typography>
                      <Box>
                        <Grid container>
                          <Grid item md={6}>
                            <Box>
                              <Typography className="d-flex align-items-center pb-1">Name : <span className="fw-bold ms-1"> {customerName ?? '--'}</span></Typography>
                              <Typography className="d-flex align-items-center pb-1">Company Name : <span className="fw-bold ms-1"> {companyName ?? '--'}</span></Typography>
                              <Typography className="d-flex align-items-center pb-1">Contact No : <span className="fw-bold ms-1">  {contactNo ?? '--'}</span></Typography>
                            </Box>
                          </Grid>
                          <Grid item md={6}>
                            <Box>
                              <Typography className="d-flex align-items-center pb-1">Address : <span className="fw-bold ms-1"> {address ?? '--'}</span></Typography>
                              <Typography className="d-flex align-items-center pb-1">Email : <span className="fw-bold ms-1"> {email ?? '--'}</span></Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                      {/* <Box className="pt-2">
                        <Typography className="fw-bold text-decoration-underline mb-2" variant="h5">Scope Of Work</Typography>
                        <Typography><span className="lightBatch"><DescriptionIcon /></span> <span className="ps-2">{description ?? '--'}</span></Typography>
                      </Box> */}
                    </div>
                  </div>
                )}
                <div className="px-3">
                  <BAGrid tableClass='table-bordered' isGrouping={true} groupName='groupName' datasource={pageList} gridCols={[
                    {
                      label: 'S.No',
                      key: 'sNo',
                      className: 'btnCell text-center'
                    },
                    {
                      label: 'Description',
                      key: 'name'
                    },
                    {
                      label: 'QTY',
                      key: 'qty',
                      displayField: (e) => <span>{e.qty} {e.unit}</span>
                    },
                    {
                      label: 'Amount',
                      key: 'amount',
                    },
                  ]} />
                  {ind == createPages(detailsArray).length - 1 && (<Box className="d-flex">
                    <table className="table w-50 border-dark ms-auto">
                      <tbody>
                        <tr>
                          <th>Installation Charges</th>
                          <td>{installationCharges || 0}</td>
                        </tr>
                        <tr>
                          <th>Total Amount</th>
                          <td>{totalAmount || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Box>
                  )}
                </div>
              </div>
              <div>
                <p className="text-center">
                  Page {ind + 1}/{createPages(detailsArray).length}
                </p>
                <PageFooter />
              </div>
            </div>
          ))}
          <div
            style={{ height: "1060px", width: "820px" }}
            className="d-flex flex-column justify-content-between"
          >
            <PageHeader />
            <div className="p-3">
              <div className="py-2">
                <Typography className="fw-bold text-decoration-underline mb-2" variant="h5">Description of Work:</Typography>
                <Typography>
                  {description ?? "--"}
                </Typography>
              </div>
              <div className="py-2">
                <Typography className="fw-bold text-decoration-underline mb-2" variant="h5">Terms and Conditions:</Typography>
                <ul>
                  <li>Payment Terms: 50% upfront, 50% upon completion of installation.</li>
                  <li>The estimated time required for manufacturing process is {estimatedDays} days.</li>
                </ul>
              </div>
              <div className="py-2">
                <Typography className="fw-bold text-decoration-underline mb-2" variant="h5">Payment Schedule:</Typography>
                <ul>
                  <li>50% Deposit</li>
                  <li>Balance Due upon Completion: Rs {totalAmount}</li>
                </ul>
              </div>
            </div>
            <PageFooter />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintEstimateDoc;
